var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"primary",attrs:{"app":""}},[_c('div',{staticClass:"white--text text-right",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.$store.getters.copy)}})])}
var staticRenderFns = []

export { render, staticRenderFns }